const RestrictionsDecorate = require('../../../../facade/restrictions/decorate');

module.exports = RestrictionsDecorate({
  haveOptions: function (selection) {
    const restrictionsFacade = require('../../../../facade/restrictions/restrictions');
    const getRestrictions = _.partial(
      restrictionsFacade.getElementRestrictions,
      selection.id
    );

    const basicRestrictions = getRestrictions('basic');
    const canReplace = basicRestrictions && basicRestrictions[0] && basicRestrictions[0].image;

    if (INKIVE.RestrictionsFacade.isRestrictedProject()) {
      return (getRestrictions('images').length ||
        getRestrictions('colors').length ||
        getRestrictions('colors-library').length ||
        canReplace);
    } else {
      return true;
    }
  }
}, { haveOptions: function () { return false; } });
